import { titleValidationSchema } from "@dzambalaorg/yup-rules";
import { object } from "yup";

// import { draftValidationSchema } from "@dzambalaorg/yup-rules";

export const validationSchema = object().shape({
  title: titleValidationSchema,
  // description: draftValidationSchema,
});
